var React = require('react');

function ArrowDownLarge (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M19.055 8.592a1.236 1.236 0 00-1.782 0l-5.349 5.494-5.347-5.494a1.236 1.236 0 00-1.783 0 1.319 1.319 0 000 1.831l6.239 6.41c.493.506 1.29.506 1.782 0l6.24-6.41a1.319 1.319 0 000-1.831","fillRule":"evenodd"}));
}

ArrowDownLarge.defaultProps = {"width":"24","height":"24"};

module.exports = ArrowDownLarge;

ArrowDownLarge.default = ArrowDownLarge;
